import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeFromWishList, selectWishlistItems } from "../Features/Wishlist/wishListSlice";
import { getImageUrl } from "../api/client";
import "./WishlistPage.css";

function resolveImage(item) {
  return getImageUrl(item.frontImg || item.image || item.images?.[0]?.url || item.images?.[0]) || item.frontImg || item.image || "";
}

export default function WishlistPage() {
  const dispatch = useDispatch();
  const items = useSelector(selectWishlistItems);

  return (
    <main className="wishlistPage">
      <div className="wishlistPageHeader">
        <p className="wishlistEyebrow">Saved rentals</p>
        <h1>Wishlist</h1>
        <p>{items.length ? `${items.length} item${items.length === 1 ? "" : "s"} saved for later.` : "Save your favourite outfits and come back when your date is set."}</p>
      </div>

      {items.length === 0 ? (
        <div className="wishlistEmpty">
          <p>Your wishlist is empty.</p>
          <Link to="/shop" className="wishlistShopLink">Browse rentals</Link>
        </div>
      ) : (
        <div className="wishlistGrid">
          {items.map((item) => {
            const id = item.productId ?? item.productID ?? item.id;
            const name = item.productName || item.name || "Rental outfit";
            return (
              <article className="wishlistCard" key={String(id)}>
                <Link to={`/product/${id}`} className="wishlistCardImageWrap">
                  {resolveImage(item) ? <img src={resolveImage(item)} alt={name} /> : <div className="wishlistImageFallback">Gem</div>}
                </Link>
                <div className="wishlistCardBody">
                  <Link to={`/product/${id}`} className="wishlistCardTitle">{name}</Link>
                  {item.productPrice || item.price ? <p className="wishlistCardPrice">₹ {Number(item.productPrice || item.price).toLocaleString("en-IN")}</p> : null}
                  <button type="button" onClick={() => dispatch(removeFromWishList(item))}>Remove</button>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </main>
  );
}
